import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, CCard, 
  CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import SupplierInputs from '../../components/SupplierInputs/SupplierInputs';
import { addSupplierRequest } from '../../store/supplier/supplierActions';

const CreateSupplier = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.supplierReducer.isLoading);
  const submitResponse = useSelector(state => state.supplierReducer.addSupplierData);

  const handleSubmit = (data) => {
    dispatch(addSupplierRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/suppliers');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/suppliers" onClick={e =>
           { e.preventDefault(); handleCancel(); }}>{t('suppliers')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createSupplier')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createSupplier')}</h4></CCardHeader>
            <CCardBody>
              <SupplierInputs onSubmit={handleSubmit} 
              onCancel={handleCancel} isLoading={isLoading} 
              submitResponse={submitResponse} />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default CreateSupplier; 